import wx from 'weixin-js-sdk';
import axios from 'axios'
import { shareLink, shareTitle, shareDesc, shareImg,appId } from 'conf/weChatShare_conf';
import router from '@/router'

const H5WeChat_init = () => {
  let formData = new FormData();
  formData.append('url',window.location.href.split("#")[0])
  formData.append('appid',appId)
  axios({
    url: "https://weizan.dianzhenkeji.com/api/jssdk.php",
    method: "post",
    // data: {
    //   url: window.location.href.split("#")[0],
    //   appid: appId
    // },
    data:formData,
    // header:{
    //   "content-type": "application/x-www-form-urlencoded"
    // },
    dataType: "json",
  })
    .then((res) => {
      let { code, data } = res.data;
      console.log(res, "res");
      if (code == 0) {
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: [
            "checkJsApi",
            "onMenuShareQQ",
            "onMenuShareWeibo",
            "onMenuShareQZone",
            "onMenuShareTimeline",
            "onMenuShareAppMessage",
          ],
        });	
      }
    })
    .catch((err) => {
      console.log(err);
    });

  wx.ready(() =>{
		wx.onMenuShareTimeline({
			title: shareTitle,
			desc: shareDesc,
			link:shareLink,
			imgUrl: shareImg,
      success:(res)=>{
        // 分享朋友圈
        if (res.errMsg == 'shareTimeline:ok') {
          router.push('/luck')
        }
        console.log(res,'onMenuShareTimeline');
      },
			cancel: () =>{},
		});
    
		wx.onMenuShareAppMessage({
			title: shareTitle,
			desc: shareDesc,
			link:shareLink,
			imgUrl: shareImg,
      success:(res)=>{
        // 分享好友
        if (res.errMsg == 'sendAppMessage:ok') {
          router.push('/luck')
        }
        console.log(res,'onMenuShareAppMessage');
      },
			cancel: function() {},
		});
    wx.onMenuShareWeibo({
			title: shareTitle,
			desc: shareDesc,
			link:shareLink,
			imgUrl: shareImg,
      success:(res)=>{
        console.log(res,'onMenuShareWeibo');
      },
			cancel: () =>{},
		});

    wx.onMenuShareQZone({
			title: shareTitle,
			desc: shareDesc,
			link:shareLink,
			imgUrl: shareImg,
      success:(res)=>{
        // QQ空间
        if (res.errMsg == 'shareQzone:ok') {
          router.push('/luck')
        }
      },
			cancel: () =>{},
		}),
    wx.onMenuShareQQ({
      title: shareTitle,
			desc: shareDesc,
			link:shareLink,
			imgUrl: shareImg,
      success:(res)=>{
        // 分享QQ
        if (res.errMsg == 'shareQQ:ok') {
          router.push('/luck')
        }
      },
			cancel: () =>{},
    })
	});	
}

export default H5WeChat_init;